import routerOptions0 from "/home/runner/work/fc-datastore/fc-datastore/client-v3/node_modules/.pnpm/nuxt@4.6.3_@azure+storage-blob@12.34.0_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29_4fb5ca28125b986a7260d096833eb34b/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto",
  sensitive: false
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}